import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-20">
        <div className="container mx-auto max-w-7xl px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">About Learners Edge</h1>
          <p className="text-xl text-blue-100">Empowering learners worldwide with quality education</p>
        </div>
      </section>

      {/* About Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Our Mission</h2>
            <p className="text-slate-700 text-lg mb-6 leading-relaxed">
              Welcome to our platform—your trusted resource for advancing a banking career with confidence. We are a dedicated team passionate about empowering existing bankers to achieve new heights through specialized certification and promotion exam preparation courses.
            </p>
            <p className="text-slate-700 text-lg mb-6 leading-relaxed">
              Our comprehensive course material is meticulously crafted in collaboration with seasoned lecturers, professors, Chartered Accountants (CAs), Company Secretaries (CSs), and leading financial experts. Each module is designed to be practical, up to date, and tailored to the real-world challenges faced by professionals in the banking sector.
            </p>
            <p className="text-slate-700 text-lg mb-6 leading-relaxed">
              Our mission is to bridge the gap between ambition and opportunity by providing accessible, expert-driven resources that support bankers at every stage of their promotional journey.
            </p>
            <p className="text-slate-700 text-lg mb-6 leading-relaxed font-semibold">
              Elevate your skills. Unlock your potential. Succeed with us.
            </p>

            <h2 className="text-3xl font-bold text-slate-900 mb-6 mt-10">Our Story</h2>
            <p className="text-slate-700 text-lg mb-6 leading-relaxed">
              Founded in 2025, Learners Edge was born from a simple yet powerful idea: that everyone deserves access to world-class education, regardless of their location or background. We've grown from a small team of passionate educators to a thriving learning platform serving thousands of students worldwide.
            </p>

            <h2 className="text-3xl font-bold text-slate-900 mb-6 mt-10">What We Offer</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div className="bg-blue-50 p-6 rounded-lg">
                <h3 className="text-xl font-semibold text-blue-600 mb-3">Expert Instructors</h3>
                <p className="text-slate-700">Learn from industry professionals and experienced educators who are passionate about teaching.</p>
              </div>
              <div className="bg-green-50 p-6 rounded-lg">
                <h3 className="text-xl font-semibold text-green-600 mb-3">Flexible Learning</h3>
                <p className="text-slate-700">Study at your own pace with 24/7 access to course materials and resources.</p>
              </div>
              <div className="bg-purple-50 p-6 rounded-lg">
                <h3 className="text-xl font-semibold text-purple-600 mb-3">Comprehensive Courses</h3>
                <p className="text-slate-700">Access a wide range of courses covering various subjects and skill levels.</p>
              </div>
              <div className="bg-orange-50 p-6 rounded-lg">
                <h3 className="text-xl font-semibold text-orange-600 mb-3">Community Support</h3>
                <p className="text-slate-700">Join a vibrant community of learners and get support throughout your journey.</p>
              </div>
            </div>

            <h2 className="text-3xl font-bold text-slate-900 mb-6 mt-10">Our Values</h2>
            <ul className="list-disc list-inside text-slate-700 text-lg space-y-3">
              <li><strong>Excellence:</strong> We strive for the highest quality in everything we do.</li>
              <li><strong>Accessibility:</strong> Education should be available to everyone, everywhere.</li>
              <li><strong>Innovation:</strong> We continuously improve and adapt to meet learners' needs.</li>
              <li><strong>Community:</strong> We believe in the power of collaborative learning.</li>
              <li><strong>Integrity:</strong> We operate with transparency and honesty in all our dealings.</li>
            </ul>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
